import type { VariantType } from '../../../../types/variant';
import {
  RECONSENT_LEAD_TEXT_REVISED,
  RECONSENT_LEAD_TEXT_SUFFIX,
  type ReconsentCopy,
  buildReconsentLeadTextPrefix,
} from '../../constants';

export type ReconsentLeadTextProps = {
  /** 表示中の規約タイプの文言。文書名とリンク先を参照する */
  copy: ReconsentCopy;
  /** 呼びかけに使う OEM 名の切り替え。省略時は RAFFLE 名になる */
  variant?: VariantType;
};

/**
 * 再承諾モーダルの見出し下に出すリード文。
 *
 * 改定された文書名を示し、全文を読めるページへ別タブで誘導する。
 * 該当ページを持たない文書（有料会員規約・ファンクラブ規約）は文書名をテキストのまま出す。
 * `RequiredConsentFlow` と Storybook で共用するため、組み立てをここに集約している。
 */
function ReconsentLeadText({ copy, variant }: ReconsentLeadTextProps) {
  return (
    <>
      {buildReconsentLeadTextPrefix(variant)}
      {copy.href ? (
        // 規約本文のスクロール中に離脱させないため別タブで開く
        <a href={copy.href} target='_blank' rel='noopener noreferrer'>
          {copy.documentName}
        </a>
      ) : (
        copy.documentName
      )}
      {RECONSENT_LEAD_TEXT_REVISED}
      {RECONSENT_LEAD_TEXT_SUFFIX}
    </>
  );
}

export default ReconsentLeadText;
